import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import SEOSchema from "./components/SEOSchema";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import WhatsAppFloat from "./components/WhatsAppFloat";
import PromoBanner from "./components/PromoBanner";
import CookieConsent from "./components/CookieConsent";

// Pages
import HomePage from "./pages/HomePage";
import ServiciosPage from "./pages/ServiciosPage";
import SoldadorasPage from "./pages/SoldadorasPage";
import TorresIluminacionPage from "./pages/TorresIluminacionPage";
import ReparacionMantenimientoPage from "./pages/ReparacionMantenimientoPage";
import GeneradoresPage from "./pages/GeneradoresPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactoPage from "./pages/ContactoPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Analytics page view tracker
const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view in Google Analytics
    if (window.gtag) {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname,
      });
    }
  }, [location]);
  
  return null;
};

function AppContent() {
  const location = useLocation();
  const [bannerVisible, setBannerVisible] = useState(false);

  // Apply body class so Header (fixed) and pages (pt-24) can offset
  useEffect(() => {
    if (bannerVisible) {
      document.body.classList.add('has-promo-banner');
    } else {
      document.body.classList.remove('has-promo-banner');
    }
  }, [bannerVisible]);

  return (
    <div className="App bg-gray-100 min-h-screen">
      <SEOSchema />
      <ScrollToTop />
      <AnalyticsTracker />
      
      <PromoBanner onVisibilityChange={setBannerVisible} />
      <Header />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/servicios/soldadoras" element={<SoldadorasPage />} />
        <Route path="/servicios/torres-de-iluminacion" element={<TorresIluminacionPage />} />
        <Route path="/servicios/reparacion-y-mantenimiento" element={<ReparacionMantenimientoPage />} />
        <Route path="/generadores" element={<GeneradoresPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contacto" element={<ContactoPage />} />
      </Routes>
      
      <Footer />
      <Toaster />
      
      {/* ChatBot */}
      <ChatBot />

      {/* WhatsApp Floating Button */}
      <WhatsAppFloat />

      {/* Cookie Consent Banner (LFPDPPP / GDPR) */}
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;